// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8249":"b50b5f10","8382":"976c3bb6"}[chunkId] + ".chunk.css";
};